import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {shortOid} from './short-oid'

export function ForcePushedText({info}: {info: IssueEventInfo}) {
  const {ref, beforeCommitOid, afterCommitOid} = info
  if (!beforeCommitOid || !afterCommitOid) return <>force pushed</>
  return (
    <>
      <span>force-pushed </span>
      {ref ? <strong>{ref}</strong> : <span>this branch</span>}
      <span> from </span>
      <strong>
        <code>{shortOid(beforeCommitOid)}</code>
      </strong>
      <span> to </span>
      <strong>
        <code>{shortOid(afterCommitOid)}</code>
      </strong>
    </>
  )
}
